import angular from 'angular';
import moment from 'moment';
import { GeracaoDeMarcacoesPadraoService } from '../geracao-de-marcacoes-padrao.service';
import {
    IGeracaoDeMarcacoesPadraoColaboradorAfetado,
    IGeracaoDeMarcacoesPadraoGet,
    IGeracaoDeMarcacoesPadraoHistorico,
    IGeracaoDeMarcacoesPadraoReversaoParcial,
    IGeracaoDeMarcacoesPadraoReversaoTotal
} from '../models/geracao-de-marcacoes-padrao.service.model';
import { ModalConfirmService } from '../../../../../shared/components/modal-confirm/modal.confirm.service';
import { IGeracaoDeMarcacoesPadraoHistoricoItemView } from './components/historico-geracao/models/historico-geracao.model';

export class GeracaoDeMarcacoesPadraoShowController {

    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        'entity',
        'GeracaoDeMarcacoesPadraoService',
        'ModalConfirmService',
        'NewToaster',
    ];

    public busy = false;
    public loadingColaboradoresAfetados = true;
    public colaboradoresAfetadosLoadError = false;
    public colaboradoresAfetados: IGeracaoDeMarcacoesPadraoColaboradorAfetado[] = [];
    public colaboradoresGerados: IGeracaoDeMarcacoesPadraoColaboradorAfetado[] = [];
    public colaboradoresRevertidos: IGeracaoDeMarcacoesPadraoColaboradorAfetado[] = [];
    public colaboradoresAfetadosSelecionados: IGeracaoDeMarcacoesPadraoColaboradorAfetado[] = [];
    public isModoReversaoParcial = false;
    public reversaoPendenteTipo: 'total' | 'parcial' | null = null;
    public isRefreshingAfterReversao = false;
    public historicoAberto = false;
    public historicoLoading = false;
    public historicoLoadError = false;
    public historicoGeracao: IGeracaoDeMarcacoesPadraoHistoricoItemView[] = [];
    public exportandoDetalhes = false;

    constructor(
        public $rootScope: angular.IRootScopeService & {
            temPermissao: (arg: string) => boolean,
            liberadoTela: (arg: string) => boolean,
        },
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public entity: IGeracaoDeMarcacoesPadraoGet,
        public GeracaoDeMarcacoesPadraoService: GeracaoDeMarcacoesPadraoService,
        public ModalConfirmService: ModalConfirmService,
        public NewToaster: { pop: (opts: { type: string; title: string; body?: string }) => void },
    ) {
        this.loadColaboradoresAfetados();

        $scope.$on('ponto_importacoesmarcacoes_trabalhadores_afetados_loaded', (event, args: IGeracaoDeMarcacoesPadraoColaboradorAfetado[]) => {
            this.loadingColaboradoresAfetados = false;
            this.colaboradoresAfetadosLoadError = false;
            this.colaboradoresAfetados = args;
            this.partitionColaboradoresAfetados();
        });

        $scope.$on('ponto_importacoesmarcacoes_trabalhadores_afetados_error', () => {
            this.loadingColaboradoresAfetados = false;
            this.colaboradoresAfetadosLoadError = true;
            this.colaboradoresAfetados = [];
            this.partitionColaboradoresAfetados();
        });

        $scope.$on('ponto_apuracoesponto_reversao_importacao_marcacoes_padrao_loaded', () => {
            this.isRefreshingAfterReversao = true;
            this.GeracaoDeMarcacoesPadraoService.get(this.entity.importacaomarcacao);
        });

        $scope.$on('ponto_apuracoesponto_reversao_importacao_marcacoes_padrao_error', (_event, error) => {
            const tipo = this.reversaoPendenteTipo;

            this.busy = false;
            this.reversaoPendenteTipo = null;
            this.isRefreshingAfterReversao = false;

            this.NewToaster.pop({
                type: 'error',
                title: `Ocorreu um erro ao confirmar a reversão ${tipo || ''}.`.trim(),
                body: this.getErrorMessage(error),
            });
        });

        $scope.$on('ponto_importacoesmarcacoes_get_loaded', (_event, entity: IGeracaoDeMarcacoesPadraoGet) => {
            this.entity = entity;

            if (!this.isRefreshingAfterReversao) {
                return;
            }

            const tipo = this.reversaoPendenteTipo;

            this.cancelarReversaoParcial();
            this.GeracaoDeMarcacoesPadraoService.getColaboradoresAfetados(this.entity.importacaomarcacao);
            this.busy = false;
            this.reversaoPendenteTipo = null;
            this.isRefreshingAfterReversao = false;

            this.NewToaster.pop({
                type: 'success',
                title: `Reversão ${tipo} iniciada com sucesso.`,
            });
        });

        $scope.$on('ponto_importacoesmarcacoes_get_error', () => {
            if (!this.isRefreshingAfterReversao) {
                return;
            }

            this.busy = false;
            this.reversaoPendenteTipo = null;
            this.isRefreshingAfterReversao = false;

            this.NewToaster.pop({
                type: 'error',
                title: 'A reversão foi iniciada, mas ocorreu um erro ao atualizar os dados da tela.',
            });
        });

        $scope.$on('ponto_importacoesmarcacoes_historico_loaded', (_event, historico: IGeracaoDeMarcacoesPadraoHistorico[]) => {
            this.historicoLoading = false;
            this.historicoLoadError = false;
            this.historicoGeracao = this.transformarHistorico(historico);
        });

        $scope.$on('ponto_importacoesmarcacoes_historico_error', () => {
            this.historicoLoading = false;
            this.historicoLoadError = true;
            this.historicoGeracao = [];
        });

        $scope.$on('ponto_importacoesmarcacoes_exportacao_loaded', (_event, file: Blob) => {
            this.downloadExportacaoXlsx(file);
            this.exportandoDetalhes = false;
        });

        $scope.$on('ponto_importacoesmarcacoes_exportacao_error', (_event, error) => {
            this.exportandoDetalhes = false;

            this.NewToaster.pop({
                type: 'error',
                title: 'Ocorreu um erro ao exportar os detalhes da geração.',
                body: this.getErrorMessage(error),
            });
        });
    }

    canReverter() {
        return this.entity.status === 2
            && (this.entity.statusreversao === null || this.entity.statusreversao === 1);
    }

    hasColaboradoresElegiveisParaReversaoParcial() {
        return this.getQuantidadeColaboradoresElegiveisParaReversaoParcial() > 1;
    }

    hasColaboradoresSelecionadosParaReversao() {
        return this.colaboradoresAfetadosSelecionados.length > 0;
    }

    hasColaboradoresGerados() {
        return this.colaboradoresGerados.length > 0;
    }

    hasColaboradoresRevertidos() {
        return this.colaboradoresRevertidos.length > 0;
    }

    getPeriodoGeracaoLabel() {
        return `${this.formatDate(this.entity.datainicial)} a ${this.formatDate(this.entity.datafinal)}`;
    }

    getApuracaoUtilizadaLabel() {
        const periodoApuracao = `${this.formatDate(this.entity.apuracaoponto.inicioapuracao)} a ${this.formatDate(this.entity.apuracaoponto.terminoapuracao)}`;

        if (this.entity.apuracaoponto.trabalhador) {
            return `${periodoApuracao} - Trabalhador: ${this.entity.apuracaoponto.trabalhador.nome || this.entity.apuracaoponto.trabalhador.trabalhador}`;
        }

        if (this.entity.apuracaoponto.lotacao) {
            return `${periodoApuracao} - Lotação: ${this.entity.apuracaoponto.lotacao.nome || this.entity.apuracaoponto.lotacao.lotacao}`;
        }

        if (this.entity.apuracaoponto.estabelecimento) {
            return `${periodoApuracao} - Estabelecimento: ${this.entity.apuracaoponto.estabelecimento.nomefantasia || this.entity.apuracaoponto.estabelecimento.estabelecimento}`;
        }

        if (this.entity.apuracaoponto.empresa) {
            return `${periodoApuracao} - Empresa: ${this.entity.apuracaoponto.empresa.razaosocial || this.entity.apuracaoponto.empresa.empresa}`;
        }

        return periodoApuracao;
    }

    hasFiltrosUtilizados() {
        return !!(
            this.getGrupoPontoLabel() ||
            this.entity.departamento ||
            this.entity.lotacao ||
            this.entity.trabalhador
        );
    }

    hasMensagemErro() {
        return !!this.entity.erro?.mensagem;
    }

    getHistoricoSubtitle() {
        return `Período ${this.getPeriodoGeracaoLabel()}`;
    }

    getHistoricoOuJustificativaTitulo() {
        return this.entity.historico ? 'Histórico' : 'Justificativa';
    }

    getHistoricoOuJustificativaValor() {
        return this.entity.historico?.descricao || this.entity.justificativa || '-';
    }

    getGrupoPontoLabel() {
        return this.entity.grupo?.nome || '';
    }

    updateColaboradoresAfetadosSelecionados(selectedItems: IGeracaoDeMarcacoesPadraoColaboradorAfetado[]) {
        this.colaboradoresAfetadosSelecionados = selectedItems;
    }

    verHistorico() {
        this.historicoAberto = true;
        this.historicoLoading = true;
        this.historicoLoadError = false;
        this.historicoGeracao = [];
        this.GeracaoDeMarcacoesPadraoService.getHistorico(this.entity.importacaomarcacao);
    }

    exportarDetalhes() {
        if (this.exportandoDetalhes) {
            return;
        }

        this.exportandoDetalhes = true;
        this.GeracaoDeMarcacoesPadraoService.exportarXlsx(this.entity.importacaomarcacao);
    }

    fecharHistorico() {
        this.historicoAberto = false;
    }

    iniciarReversaoParcial() {
        if (!this.canReverter() || !this.hasColaboradoresElegiveisParaReversaoParcial()) {
            return;
        }

        this.isModoReversaoParcial = true;
        this.colaboradoresAfetadosSelecionados = [];
    }

    cancelarReversaoParcial() {
        this.isModoReversaoParcial = false;
        this.colaboradoresAfetadosSelecionados = [];
    }

    confirmarReversaoTotal() {
        if (!this.canReverter()) {
            return;
        }

        const confirm = this.ModalConfirmService.open({}, 'reversão da geração de marcações padrão', false, {
            title: 'Reverter totalmente',
            confirmText: 'Tem certeza que deseja reverter totalmente esta geração de marcações padrão?',
            alertInfo: {
                header: 'Atenção',
                text: 'A reversão será realizada e poderá levar alguns minutos para ser refletida no relatório de ponto.',
            },
            closeButton: 'Cancelar',
            confirmButton: 'Sim, reverter totalmente',
        });

        confirm.result
            .then(() => {
                this.submitReversao(this.buildReversaoTotalPayload(), 'total');
            })
            .catch(() => { /* modal cancelada */ });
    }

    confirmarReversaoParcial() {
        if (!this.canReverter() || !this.hasColaboradoresSelecionadosParaReversao()) {
            return;
        }

        const confirm = this.ModalConfirmService.open({}, 'reversão parcial da geração de marcações padrão', false, {
            title: 'Reverter parcialmente',
            confirmText: `Tem certeza que deseja reverter as marcações padrão de ${this.colaboradoresAfetadosSelecionados.length} colaborador(es)?`,
            alertInfo: {
                header: 'Atenção',
                text: 'A reversão será realizada e poderá levar alguns minutos para ser refletida no relatório de ponto.',
            },
            closeButton: 'Cancelar',
            confirmButton: 'Sim, reverter parcialmente',
        });

        confirm.result
            .then(() => {
                this.submitReversao(this.buildReversaoParcialPayload(), 'parcial');
            })
            .catch(() => { /* modal cancelada */ });
    }

    formatDate(date?: string | null) {
        return date ? moment(date).format('DD/MM/YYYY') : '-';
    }

    private submitReversao(
        payload: IGeracaoDeMarcacoesPadraoReversaoTotal | IGeracaoDeMarcacoesPadraoReversaoParcial,
        tipo: 'total' | 'parcial',
    ) {
        this.busy = true;
        this.reversaoPendenteTipo = tipo;
        this.isRefreshingAfterReversao = false;

        this.GeracaoDeMarcacoesPadraoService.reverter({
            apuracaoponto: this.entity.apuracaoponto.apuracaoponto,
            importacaomarcacao: this.entity.importacaomarcacao
        }, payload);
    }

    private loadColaboradoresAfetados() {
        this.loadingColaboradoresAfetados = true;
        this.colaboradoresAfetadosLoadError = false;

        return this.GeracaoDeMarcacoesPadraoService.getColaboradoresAfetados(this.entity.importacaomarcacao);
    }

    private buildReversaoTotalPayload(): IGeracaoDeMarcacoesPadraoReversaoTotal {
        const isSelecaoPorTrabalhador = !!this.entity.trabalhador?.trabalhador;

        return {
            datainicial: this.entity.datainicial,
            datafinal: this.entity.datafinal,
            trabalhadores: isSelecaoPorTrabalhador ? [{ trabalhador: this.entity.trabalhador.trabalhador }] : [],
            empresa: this.entity.log.contexto.empresa || this.entity.empresa?.empresa || '',
            estabelecimento: isSelecaoPorTrabalhador ? '' : (this.entity.log.contexto.estabelecimento || ''),
            departamento_colaboradores: isSelecaoPorTrabalhador ? null : this.entity.log.contexto.departamento_colaboradores,
            lotacao_colaboradores: isSelecaoPorTrabalhador ? null : this.entity.log.contexto.lotacao_colaboradores,
            grupo_colaboradores: isSelecaoPorTrabalhador ? null : this.entity.log.contexto.grupo_colaboradores,
        };
    }

    private buildReversaoParcialPayload(): IGeracaoDeMarcacoesPadraoReversaoParcial {
        return {
            trabalhadores: this.colaboradoresAfetadosSelecionados.map((item) => ({
                trabalhador: item.trabalhador,
            })),
        };
    }

    private transformarHistorico(historico: IGeracaoDeMarcacoesPadraoHistorico[]) {
        if (!Array.isArray(historico)) {
            return [];
        }

        return historico.map((item): IGeracaoDeMarcacoesPadraoHistoricoItemView => {
            const mensagensErro = [
                item.erro?.mensagem || '',
                item.erro?.detalhe || '',
            ].filter(Boolean);

            return {
                id: item.historicoimportacaomarcacao,
                titulo: this.getTipoHistoricoLabel(item.tipo),
                dataHora: this.formatDateTime(item.created_at),
                responsavel: item.created_by?.nome || '',
                descricao: mensagensErro.join(' - '),
                indicatorClass: this.getHistoricoIndicatorClass(item),
            };
        });
    }

    private getTipoHistoricoLabel(tipo: number) {
        switch (tipo) {
            case 0:
                return 'Geração';
            case 1:
                return 'Reversão parcial';
            case 2:
                return 'Reversão total';
            default:
                return 'Movimentação';
        }
    }

    private getHistoricoIndicatorClass(item: IGeracaoDeMarcacoesPadraoHistorico) {
        if (item.erro) {
            return 'indicator--warning';
        }

        if (item.tipo === 0) {
            return 'indicator--success';
        }

        return 'indicator--info';
    }

    private formatDateTime(date?: string | null) {
        return date ? moment(date).format('DD/MM/YYYY [às] HH:mm') : '';
    }

    private getQuantidadeColaboradoresElegiveisParaReversaoParcial() {
        return this.colaboradoresGerados.length;
    }

    private partitionColaboradoresAfetados() {
        this.colaboradoresGerados = this.colaboradoresAfetados.filter((item) => !item.revertido);
        this.colaboradoresRevertidos = this.colaboradoresAfetados.filter((item) => item.revertido);
    }

    private getErrorMessage(error: any) {
        return error?.data?.message || error?.data?.mensagem || error?.data?.erro || undefined;
    }

    private downloadExportacaoXlsx(file: Blob) {
        const periodoGeracao = this.getPeriodoGeracaoArquivoLabel();
        const fileURL = window.URL.createObjectURL(file);
        const a = document.createElement('a');

        document.body.appendChild(a);
        a.style.display = 'none';
        a.href = fileURL;
        a.download = `geracao_marcacoes_padrao_${periodoGeracao}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(fileURL);
        document.body.removeChild(a);
    }

    private getPeriodoGeracaoArquivoLabel() {
        const dataInicial = moment(this.entity.datainicial);
        const dataFinal = moment(this.entity.datafinal);

        if (!dataInicial.isValid() || !dataFinal.isValid()) {
            return 'periodo_indisponivel';
        }

        return `${dataInicial.format('DD-MM-YYYY')}_a_${dataFinal.format('DD-MM-YYYY')}`;
    }
}
